import { h, render } from 'preact';
import { delay } from './election-utils';

// just in case this gets removed
window.ttData = window.ttData || {};

// related content
const relatedContentContainer = document.getElementById(
  'related-content-container'
);

if (relatedContentContainer && window.ttData.related_category) {
  import(
    /* webpackChunkName: "RelatedContent" */ './components/RelatedContent'
  ).then(({ default: RelatedContent }) =>
    render(
      <RelatedContent
        title={'Read more'}
        related_category={window.ttData.related_category}
      />,
      relatedContentContainer
    )
  );
}

import(/* webpackChunkName: "ads" */ './utils/ad-loader').then(
  ({ default: AdLoader }) => {
    delay(function() {
      const ads = new AdLoader();
      ads.init();
    }, 600); // end delay
  }
);
